/**
 * Extracts a user-facing error message from an unknown catch value.
 * Handles Axios error responses (with `response.data.error` shape) and
 * plain Error instances, falling back to the provided default message.
 */
export function extractApiErrorMessage(
  err: unknown,
  fallback = 'Something went wrong. Please try again.'
): string {
  if (
    err &&
    typeof err === 'object' &&
    'response' in err &&
    err.response &&
    typeof err.response === 'object' &&
    'data' in err.response &&
    err.response.data &&
    typeof err.response.data === 'object' &&
    'error' in err.response.data
  ) {
    return String((err.response.data as { error: string }).error);
  }
  if (err instanceof Error) {
    return err.message;
  }
  return fallback;
}
